import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Backdrop from '@material-ui/core/Backdrop';
import styled from 'styled-components';

export const DialogWrapper = ({ children, ...props }) => (
  // eslint-disable-next-line no-use-before-define
  <Dialog {...props} BackdropComponent={BackdropComponent} fullScreen scroll='body'>
    {children}
  </Dialog>
);

const BackdropComponent = styled(Backdrop)`
  &.MuiBackdrop-root {
    background-color: ${({ theme }) => theme?.colors?.greyOverlay};
  }
`;
